import React from "react";
import { string, func, bool } from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const ModalWithLauncher = ({ title = "", Launcher, Content, mx = true }) => {
  const [modalOpen, setOpen] = React.useState(false);

  const handleModalOpen = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleModalClose = (event) => {
    event.preventDefault();
    setOpen(false);
  };

  const modalGraphicOrText = (
    <a // eslint-disable-line jsx-a11y/anchor-is-valid
      role="button"
      href="#"
      onClick={handleModalOpen}
      aria-label={`Open ${title}`}
      aria-haspopup="true"
    >
      <Launcher />
    </a>
  );

  return (
    <>
      {modalGraphicOrText}
      <Dialog
        fullWidth
        maxWidth="md" // 'lg' 'md' 'sm' 'xl' 'xs' false
        // fullScreen={true}
        open={modalOpen}
        onClose={handleModalClose}
        sx={{
          "& .MuiDialogActions-root": {
            justifyContent: "space-between",
            padding: "8px 16px 8px 16px",
            "& .MuiDialogTitle-root": {
              padding: 0,
            },
          },
          "& .MuiDialogContent-root": mx
            ? {
                margin: "0 0 8px 0",
                padding: "0 16px 8px 16px",
              }
            : {
                margin: "0 0 8px 0",
                padding: "0 0 8px 0",
              },
        }}
      >
        <DialogActions>
          <DialogTitle>{title}</DialogTitle>
          <Button variant="text" onClick={handleModalClose}>
            Close
          </Button>
        </DialogActions>
        <DialogContent>
          <Content />
        </DialogContent>
      </Dialog>
    </>
  );
};

ModalWithLauncher.propTypes = {
  i18nKey: string.isRequired,
  title: string,
  Launcher: func,
  Content: func,
  mx: bool,
};

export default ModalWithLauncher;
